import {
  distributorSetData,
  forumData,
  groupData,
  merchantsData,
  vipData
} from "./sidebar.js/index";

export const initSideBar = {
  distributorSetData,
  forumData,
  groupData,
  merchantsData,
  vipData,
  integralMalls: [
    {
      path: "/apply/integralMall/14/prodduct",
      name: "商品管理"
    },
    {
      path: "/apply/integralMall/14/order",
      name: "兑换记录"
    }
  ],
  signData: [
    {
      path: "/apply/sign/7/set",
      name: "签到规则设置"
    },
    {
      path: "/apply/sign/7/signList",
      name: "签到记录"
    }
  ],
  couponData: [
    {
      path: "/apply/coupon/9/ticket",
      name: "优惠券管理"
    },
    {
      path: "/apply/coupon/9/discounts",
      name: "优惠券核销"
    },
    {
      path: "/apply/coupon/9/grant",
      name: "优惠券领取记录"
    }
    // {
    //   path: "",
    //   name: "添加优惠券",
    // }
  ],
  storeManage: [
    {
      path: "/apply/storeManage/15/storeList",
      name: "门店管理"
    }
  ],
  employee: [
    {
      path: "/apply/employee/16/employeeList",
      name: "员工列表"
    },
    {
      path: "/apply/employee/16/role",
      name: "角色管理"
    }
  ],
  pointSetting: [
    {
      path: "/apply/point/17/pointSetting",
      name: "积分设置"
    }
  ],
  couponSetting: [
    {
      path: "/apply/couponSetting/19/Setting",
      name: "优惠券设置"
    }
  ],

  fullReductionData: [
    {
      path: "/apply/fullReduction/20/frlist",
      name: "满减活动管理"
    }
  ],
  fullPackageData: [
    {
      path: "/apply/fullPackage/21/frlist",
      name: "满包邮活动管理"
    }
  ],
  luckyDrawData: [
    {
      path: "/apply/luckyDraw/22/turntableList",
      name: "转盘抽奖"
    },
    {
      path: "/apply/luckyDraw/22/orderRecord",
      name: "兑换记录"
    }
  ]
};
